import React from "react";
import propTypes from "prop-types";
import Icon from "../icons/Icon";
import classnames from "classnames";
import "./Label.scss";

const Label = ({
  label,
  labelElement,
  htmlFor,
  required,
  className,
  children,
  labelPosition = "before"
}) => {
  const labelClasses = classnames("uikit__label", {
    [`${className}__label`]: className
  });
  const labelTextClasses = classnames("uikit__label__text", {
    [`${className}__label__text`]: className
  });
  const labelElementClasses = classnames("uikit__label__element", {
    [`${className}__label__element`]: className
  });

  if (!label && !labelElement) {
    return (
      <span className={labelClasses}>
        {labelPosition === "after" && children}
        <span className={`uikit__label__spacer`}>&nbsp;</span>
        {labelPosition === "before" && children}
      </span>
    );
  }
  return (
    <label htmlFor={htmlFor} className={labelClasses}>
      {labelPosition === "after" && children}
      {label && <span className={labelTextClasses}>{label}</span>}
      {labelElement && (
        <span className={labelElementClasses}>{labelElement}</span>
      )}
      {required && (
        <span className="uikit__required-asterisk__container">
          <Icon className="uikit__required-asterisk" icon="farAsterisk" />
          <span className="uikit-sr-only">required</span>
        </span>
      )}
      {labelPosition === "before" && children}
    </label>
  );
};

export default Label;

Label.propTypes = {
  label: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
    propTypes.element,
    propTypes.func
  ]),
  htmlFor: propTypes.oneOfType([propTypes.string, propTypes.number]),
  required: propTypes.bool,
  labelElement: propTypes.element,
  className: propTypes.string,
  children: propTypes.node,
  labelPosition: propTypes.oneOf(["before", "after"])
};
